import { useSelector } from 'react-redux';

import { FormsEnum } from 'app/shared/enums';
import { RootState } from 'app/store/rootReducer';
import { getQuestions } from 'app/store/data/formsConfig';

export function useFormConfig(formName: FormsEnum) {
  const questions = useSelector((state: RootState) =>
    getQuestions(state, formName)
  );

  return {
    questions,
  };
}
